import React from 'react';

import { ImageSize } from '@nxte-nl/image-hooks';

import { versionDependent } from '../../images/versionDependentExport';
import { ImagePresentational } from '../../types/common';
import { ImageWithSize } from '../ImageWithSize/ImageWithSize';
import { LayoutWrapper } from '../LayoutWrapper/LayoutWrapper';
import { Trustmarks } from '../Trustmarks/Trustmarks';
import styles from './FooterLogos.module.css';

export type Props = {
  footerImages: ImagePresentational[];
};

export const FooterLogos = React.memo(({ footerImages }: Props) => {
  return (
    <>
      <LayoutWrapper>
        <section className={styles.footerLogos}>
          {
            <div className={styles.logosBlock}>
              {footerImages.map(image => (
                <ImageWithSize key={image.url.href} image={image} size={ImageSize.original} />
              ))
              }
            </div>
          }
          <Trustmarks
            className={styles.trustMarks}
            trustMarks={versionDependent.trustMarksBottomBar}
          />
        </section>
      </LayoutWrapper>
    </>
  );
});

FooterLogos.displayName = 'FooterLogos';
